import React, { useState } from "react";
import errorImage from "../assets/images/404-Error-Page.svg";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Logo from "../assets/images/LOGO.png";
import { useUser } from "@clerk/clerk-react";
// import Searchbar from "./Search";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
  UserButton,
} from "@clerk/clerk-react";
import { Link, useLocation } from "react-router-dom";
import { searchProvider } from "../api/api-methods";
import { useGetVendorsMe } from "../custom-hooks/queries";
import { useUserRole } from "../utils/helperMethods";

const userNavigation = [
  { name: "Your Profile", href: "#" },
  { name: "Settings", href: "#" },
  { name: "Sign out", href: "#" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const ComingSoon = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isSignedIn, user } = useUser();
  const [searchProviders, setSearchProviders] = useState([]);
  const userRole = useUserRole();
  const { data } = useGetVendorsMe(userRole);

  const handleSearch = async (searchText) => {
    try {
      const data = await searchProvider(searchText);
      setSearchProviders(data);
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  };
  return (
    <>
      <div className="bg-custom-grey-color">
        <Transition show={sidebarOpen}>
          <Dialog className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
            <TransitionChild
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </TransitionChild>

            <div className="fixed inset-0 flex">
              <TransitionChild
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <TransitionChild
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </TransitionChild>
                  <div className="bg-custom-grey-color flex grow flex-col gap-y-5 overflow-y-auto px-6 pb-4">
                    <div className="flex h-16 shrink-0 justify-center items-center mt-8">
                      <img
                        className=""
                        src={Logo}
                        alt="Your Company"
                        height={75}
                        width={150}
                      />
                    </div>
                    {/* Add sidebar content here if needed */}
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </Dialog>
        </Transition>

        <div className="bg-custom-grey-color lg:pl-72">
          <div className="bg-custom-grey-color sticky py-2 top-0 z-40 lg:mx-auto lg:px-8">
            <div className="flex h-16 items-center gap-x-4 bg-custom-grey-color px-2 shadow-sm sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none">
              <button
                type="button"
                className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <span className="sr-only">Open sidebar</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>

              <div className="flex items-center justify-end bg-custom-grey-color flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                {/* {isSignedIn && (
                  <div className="hidden md:block text-xl lg:text-2xl xl:text-2xl font-semibold text-custom-464255-color">
                    {isSignedIn && <p>Welcome, {user.firstName}</p>}
                  </div>
                )} */}
                {/* <div className="w-custom-width">
                  <Searchbar
                    placeholder="Search here..."
                    height="74px"
                    width="569px"
                    onSearch={handleSearch}
                    isFilterSearch={false}
                    isSearchIcon={true}
                  />
                </div> */}
                <div className="flex justify-end items-center">
                  {/* {isSignedIn && (
                    <button
                      type="button"
                      className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
                    >
                      <span className="sr-only">View notifications</span>
                      <BellIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  )} */}

                  <div>
                    <header className="flex justify-end">
                      <SignedOut redirectUrl="/">
                        <SignInButton style={{ marginRight: "20px" }} />
                        <SignUpButton />
                      </SignedOut>

                      <SignedIn>
                        <UserButton />
                      </SignedIn>
                    </header>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center">
        <h1>Coming soon</h1>
      </div>
    </>
  );
};
